import SelectableSearchableSortableListCtrl from '../manage/SelectableSearchableSortableListCtrl';
import { USERS_COLUMN_DESCRIPTIONS } from '../../users/constants';
import {
  EMPLOYEE_HEADER_HEIGHT,
  ACTION_BAR_HEIGHT,
  TIMEZONE_BANNER_HEIGHT,
  FILTERS_BAR_HEIGHT,
} from '../constants';

import usersGroupComponentUrl from './usersGroupComponent.html';

const SECTION_TITLE_DICT = {
  regularUsers: 'Employees',
  notInvitedUsers: 'Not invited employees',
  invitedUsers: 'Invited employees',
  deactivatedUsers: '',
  selfInvitedUsers: '',
};

class UsersGroupCtrl extends SelectableSearchableSortableListCtrl {
  tableHeaderLabels = USERS_COLUMN_DESCRIPTIONS;

  constructor(
    Authentication,
    PersonaCollection,
    UserUtils,
    filterFilter,
    orderByFilter,
    $parse,
    $scope,
    $rootScope
  ) {
    'ngInject';

    super(filterFilter, $parse, 'searchValue', (invalidateFn) => {
      $scope.$on('$destroy', PersonaCollection.onChange(invalidateFn));
    });

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      UserUtils,
      filterFilter,
      orderByFilter,
      $parse,
      $scope,
      $rootScope,
    });
  }

  SECTION_TITLE_DICT = SECTION_TITLE_DICT;

  $onInit() {
    this.manageMode = this.Authentication.user.isManager;
    this.canManageUser = this.UserUtils.canManageUser.bind(this.UserUtils);
    this.canEditUser = this.UserUtils.canEditUser.bind(this.UserUtils);
    this.sortMethod = 'normalizedDisplayName';
    this.updateOrderedUsers();
    this.hasImportedUsers = this.PersonaCollection.hasImportedUsers;
  }

  getManageTableRowSize(user) {
    const isExpanded = {
      positions: user.$$positionsExpanded,
      locations: user.$$locationsExpanded,
      groups: user.$$groupsExpanded,
    };

    const isGroupVisible = (property) => {
      const column = this.getColumnByProperty(property);
      return column && column.active && !this.shouldHideColumn({ column });
    };

    return this.UserUtils.getManageTableRowSize(user, isExpanded, isGroupVisible);
  }

  getUserImportedTooltipMessage({ origin }) {
    if (!origin) {
      return '';
    }

    const capitalizedOrigin = origin.charAt(0).toUpperCase() + origin.slice(1);
    return `Users imported from ${capitalizedOrigin} can't be deleted.`;
  }

  $onDestroy() {
    if (this.deselectGroup) {
      this.deselectGroup({ groupName: this.groupName });
    }
  }

  isColumnActive(columnProperty) {
    const column = this.getColumnByProperty(columnProperty);

    return !column || !this.shouldHideColumn({ column });
  }

  getColumnByProperty(columnProperty) {
    return this.columns.reportColumns.find((item) => item.property === columnProperty);
  }

  get isSelfInvitedUsersTable() {
    return this.groupName === 'selfInvitedUsers';
  }

  get visibleItems() {
    if (!this._visibleItems) {
      const filterArg = this._searchProp ? { [this._searchProp]: this.search } : this.search;
      this._visibleItems = this.items ? this.filterFilter(this.items, filterArg) : [];
      this.updateOrderedUsers();
    }

    return this._visibleItems;
  }

  get users() {
    /**
     * SelectableSearchableSortableListCtrl uses this.items
     * this getter/setter is a suger that allows us not to use
     * the generic this.items in this component
     */
    return this.visibleItems;
  }

  set users(value) {
    this.items = value;
  }

  get stickyHeaderHeight() {
    return (
      this.$rootScope.navbarHeight +
      EMPLOYEE_HEADER_HEIGHT +
      (this.isSomethingSelected ? ACTION_BAR_HEIGHT : 0) +
      (this.$rootScope.timezoneDiscrepancyShown ? TIMEZONE_BANNER_HEIGHT : 0) +
      (this.filtersOpened ? FILTERS_BAR_HEIGHT : 0)
    );
  }

  sortBy(sortMethod, prop) {
    super.sortBy(sortMethod, prop);

    if (!this._visibleItems) {
      this.orderedUsers = this.visibleItems;
    } else {
      this.updateOrderedUsers();
    }
  }

  updateOrderedUsers() {
    this.orderedUsers = this.orderByFilter(this.users, this.orderBy(this.sortMethod));
  }

  onSelectAllItems() {
    if (this.isAllSelected) {
      const changes = this.selectedItemIds;
      this.onSelectionChange({ changes });
      return;
    }

    this.deselectGroup({ groupName: this.groupName });
  }
}

export default {
  bindings: {
    search: '=',
    selectedItemIds: '=',
    isSomethingSelected: '=',
    visibleItemsDict: '=',
    users: '<',
    groupName: '<',
    disableBulkActions: '<?',
    openStatusInfo: '&',
    deactivateUsers: '&',
    activateUsers: '&',
    deleteUsers: '&',
    mergeUsers: '&',
    acceptInviteRequest: '&',
    rejectInviteRequest: '&',
    deselectGroup: '&',
    filtersOpened: '<',
    columns: '<',
    shouldHideColumn: '&',
    onSelectionChange: '&',
  },
  controllerAs: 'ctrl',
  controller: UsersGroupCtrl,
  templateUrl: usersGroupComponentUrl,
};
